import { render, staticRenderFns } from "./GroupRequest.vue?vue&type=template&id=2b71a5d1&scoped=true"
import script from "./GroupRequest.vue?vue&type=script&lang=js"
export * from "./GroupRequest.vue?vue&type=script&lang=js"
import style0 from "./GroupRequest.vue?vue&type=style&index=0&id=2b71a5d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b71a5d1",
  null
  
)

export default component.exports